import _defineProperty from "@babel/runtime/helpers/defineProperty";
import XdomainStorage from '@ali/xdomain-storage';
import { TRIGGER_WAY } from './api';
import { get, set, del } from './indexdb';

// const xdomainStorage = new XdomainStorage();

var xdomainStorage = null;
export var initXdomainStorage = function initXdomainStorage(frameURL) {
  xdomainStorage = new XdomainStorage(frameURL);
};

// TODO `aem-${key}` 注意加aem前缀
export var XdomainStorageKeys = {
  UnOpenSurvey: 'plugin-unopen-survey-ids',
  SurveyShowTimes: 'plugin-survey-show-times',
  SurveyShowedInfo: 'plugin-survey-showed-info',
  SurveyBehaviorInfo: 'plugin-survey-behavior-info',
  SurveyConfigVersions: 'plugin-survey-config-versions'
};
var ONE_DAY = 24 * 60 * 60 * 1000;
var xdomainFull = false;
var getXdomainStorage = function getXdomainStorage(key) {
  return Promise.race([new Promise(function (r, j) {
    xdomainStorage.getItem(key).then(function (x) {
      return r(x || []);
    }).catch(function (x) {
      r(Array.isArray(x) ? x : []);
    });
  }), new Promise(function (r) {
    return setTimeout(function () {
      r([]);
    }, 1000);
  })]);
};
export var _getStorage = function _getStorage(key) {
  try {
    // xdomain存得下就读xdomain优先
    if (!xdomainFull) {
      return new Promise(function (resolve, reject) {
        getXdomainStorage(key).then(function (xlist) {
          if (xlist !== null && xlist !== void 0 && xlist.length) {
            resolve(xlist);
          } else {
            get("aem-".concat(key)).then(function (flist) {
              var _JSON$parse;
              if ((_JSON$parse = JSON.parse(flist)) !== null && _JSON$parse !== void 0 && _JSON$parse.length) {
                resolve(JSON.parse(flist));
              }
              resolve([]);
            }).catch(function (e) {
              resolve([]);
            });
          }
        }).catch(function (e) {
          resolve([]);
        });
      });
    } else {
      // xdomain存不下就读indexdb
      return new Promise(function (resolve, reject) {
        get("aem-".concat(key)).then(function (flist) {
          var _JSON$parse2;
          if ((_JSON$parse2 = JSON.parse(flist)) !== null && _JSON$parse2 !== void 0 && _JSON$parse2.length) {
            resolve(JSON.parse(flist));
          }
          resolve([]);
        }).catch(function (e) {
          resolve([]);
        });
      });
    }
  } catch (error) {
    return Promise.resolve([]);
  }
};
var filterSurveyList = function filterSurveyList(surveyList, list, pid) {
  var result = (list || []).filter(function (item) {
    // 先把pid添加到历史数据去
    var sameId = (surveyList || []).some(function (survey) {
      return item.id === survey.id;
    });
    if (!(item !== null && item !== void 0 && item.pid) && sameId) {
      item.pid = pid;
    }
    ;
    // 过滤那些pid一致且在项目里不存在的
    return !((item === null || item === void 0 ? void 0 : item.pid) === pid && !sameId);
  });
  return result;
};
export var clearStorage = function clearStorage(surveyList, pid) {
  try {
    var _loop = function _loop(key) {
      // xdomain的清除
      getXdomainStorage(XdomainStorageKeys[key]).then(function (list) {
        var result = filterSurveyList(surveyList, list, pid);
        result && xdomainStorage.setItem(XdomainStorageKeys[key], result).then(function (res) {}).catch(function (e) {
          xdomainFull = true;
        });
      });
      // indexdb的清除
      get("aem-".concat(XdomainStorageKeys[key])).then(function (list) {
        var result = filterSurveyList(surveyList, JSON.parse(list || '[]'), pid);
        result && set("aem-".concat(XdomainStorageKeys[key]), JSON.stringify(result));
      });
    };
    for (var key in XdomainStorageKeys) {
      _loop(key);
    }
  } catch (error) {}
};
export var _setStorage = function _setStorage(key, data) {
  try {
    // TODO：当用户升级插件的差不多时再去掉xdomain，减小体积
    set("aem-".concat(key), JSON.stringify(data));
    if (!xdomainFull) {
      xdomainStorage.setItem(key, data).then(function (res) {}).catch(function (e) {
        xdomainFull = true;
      });
    }
  } catch (error) {
    console.error('[AES] plugin-survey', 'fail to write buffer');
  }
};
var _checkMatchHref = function _checkMatchHref(triggerContent) {
  // 对零宽负向先行断言 做替换处理
  var reg = new RegExp(triggerContent.replace(/\(\(\?\!/g, '零宽断言占位1').replace(/\)\.\)\*/g, '零宽断言占位2').replace(/([\/\?\.])/g, '\\$1').replace(/\*/g, '.*').replace(/零宽断言占位1/g, '((?!').replace(/零宽断言占位2/g, ').)*'));
  // const reg = new RegExp(triggerContent.replace(/([\/\?\.])/g, '\\$1').replace(/\*/g, '.*'));
  return reg.test(location.href) || location.href.indexOf(triggerContent) == 0;
};
export var checkMatchHref = function checkMatchHref(triggerContent) {
  var regList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!regList.length) {
    // 老版本数据，没有列表
    return _checkMatchHref(triggerContent);
  } else {
    // 新版本数据，有黑名单匹配
    var includeItem = (regList.find(function (x) {
      return x.type == 'include';
    }) || {}).children || []; // 白名单规则
    var exceptItem = (regList.find(function (x) {
      return x.type == 'except';
    }) || {}).children || []; // 黑名单规则

    // 白名单是否命中
    var includeMatch = includeItem.some(function (x) {
      return _checkMatchHref(x.value || '');
    });
    // 黑名单是否命中
    var exceptMatch = exceptItem.some(function (x) {
      return _checkMatchHref(x.value || '');
    });
    if (includeItem.length) {
      if (exceptItem.length) {
        // 有白名单/黑名单
        return includeMatch && !exceptMatch;
      }

      // 只有白名单规则
      return includeMatch;
    } else {
      // 只有黑名单规则
      return !exceptMatch;
    }
  }
};
export var checkTriggerWay = function checkTriggerWay(triggerSetting) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$behaviorType = _ref.behaviorType,
    behaviorType = _ref$behaviorType === void 0 ? '0' : _ref$behaviorType,
    _ref$behaviorData = _ref.behaviorData,
    behaviorData = _ref$behaviorData === void 0 ? [] : _ref$behaviorData;
  // 触发方式、触发页面
  // 脚本触发
  if (triggerSetting.triggerWay === TRIGGER_WAY.CUSTOMIZED) {
    if (behaviorType == '1') {
      // 行为触发
      return !behaviorData.filter(function (x) {
        return (x || []).filter(function (item) {
          return item.range == 'special' && !checkMatchHref(item.rangeDetail);
        }).length;
      }).length;
    } else {
      // 脚本触发
      return false;
    }
  }

  // 自动触发 - 所有页面
  if (triggerSetting.triggerWay === TRIGGER_WAY.ALL) {
    return true;
  }

  // 自动触发 - 指定页面
  if (triggerSetting.triggerWay === TRIGGER_WAY.SPECIFIC && triggerSetting.triggerContent && checkMatchHref(triggerSetting.triggerContent, triggerSetting.triggerContentList || [])) {
    return true;
  }
  return false;
};

// true 被疲劳控制
export var checkoutFrequency = function checkoutFrequency() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var surveyId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var showedList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _ref2 = settings || {},
    frequencyList = _ref2.frequencyList;
  var canopen = true;
  (frequencyList || []).filter(function (x) {
    return x.ids.includes(surveyId);
  }).forEach(function (_ref3) {
    var ids = _ref3.ids,
      days = _ref3.days,
      showNum = _ref3.showNum;
    var list = showedList.filter(function (item) {
      return ids.find(function (id) {
        return item.id == id;
      });
    }).filter(function (item) {
      return item.cycleDate > Date.now() - days * ONE_DAY;
    });
    if (list.length < showNum || list.length == showNum && list.find(function (x) {
      return x.id == surveyId;
    })) {
      // 可以展示
      // canopen = true;
    } else {
      canopen = false;
    }
  });
  return !canopen;
};
//
export var getShowsFrequency = function getShowsFrequency() {
  return _getStorage(XdomainStorageKeys.SurveyShowedInfo).then(function (ids) {
    return ids || [];
  });
};

// 更新本次问卷展示的时间
export var addShowsFrequency = function addShowsFrequency(id, pid) {
  getShowsFrequency().then(function (ids) {
    ids = ids.filter(function (x) {
      return x.id != id;
    });
    ids.push({
      id: id,
      cycleDate: Date.now(),
      pid: pid
    });
    _setStorage(XdomainStorageKeys.SurveyShowedInfo, ids);
  });
};
export var getUnOpenSurvey = function getUnOpenSurvey(returnFull) {
  return _getStorage(XdomainStorageKeys.UnOpenSurvey).then(function (ids) {
    return (ids || []).filter(function (item) {
      if (returnFull) {
        return true;
      }
      if (typeof item == 'object' && Number(item.cycleDate)) {
        return Number(item.cycleDate) > -10000 ? Date.now() < Number(item.cycleDate) : true;
      } else {
        return false;
      }
    }).map(function (item) {
      if (typeof item == 'object' && !returnFull) {
        return item.id;
      } else {
        return item;
      }
    });
  });
};

// 不再展示
export var addUnOpenSurvey = function addUnOpenSurvey(id, cycle, pid) {
  var cycleDate = Date.now();
  if (cycle == '-1') {
    // 周期 永不再展示
    cycleDate = -99999;
  } else {
    cycleDate += Number(cycle) * ONE_DAY;
  }
  getUnOpenSurvey(true).then(function (ids) {
    ids = (ids || []).filter(function (x) {
      return typeof x === 'object' ? x.id != id : x != id;
    });
    ids.push({
      id: id,
      cycleDate: cycleDate,
      pid: pid
    });
    _setStorage(XdomainStorageKeys.UnOpenSurvey, ids);
  });
};

// 控制是否不再展开了
var setShowOrOpen = function setShowOrOpen(_ref4) {
  var id = _ref4.id,
    showTimes = _ref4.showTimes,
    isPreview = _ref4.isPreview,
    showCycle = _ref4.showCycle,
    pid = _ref4.pid;
  showTimes = Number(showTimes) || 0;
  var times, originTimes;
  _getStorage(XdomainStorageKeys.SurveyShowTimes).then(function (list) {
    list = list || [];
    var item = list.find(function (x) {
      return x.id == id;
    });
    if (item) {
      times = item.showTimes;
      originTimes = item.originTimes;
    } else {
      times = -999;
      originTimes = '';
    }
    if (times != -999 && originTimes == showTimes) {
      // 之前打开过的 且 与原来的设置一样
      --times;
      if (times < 1) {
        // 次数用完，不再展示了
        !isPreview && addUnOpenSurvey(id, showCycle, pid);
        times = -999;
        showTimes = '';
      }
      changeShowTimes({
        id: id,
        showTimes: times,
        originTimes: showTimes,
        pid: pid
      });
      return;
    }
    if (showTimes <= 1) {
      // 次数用完，不再展示了
      !isPreview && addUnOpenSurvey(id, showCycle, pid);
      changeShowTimes({
        id: id,
        showTimes: -999,
        originTimes: '',
        pid: pid
      });
      return;
    }
    // 从来没有打开过，直接判断传入的显示次数，存起来下次用
    // 或者 与之前的设置不一样
    changeShowTimes({
      id: id,
      showTimes: showTimes - 1,
      originTimes: showTimes,
      pid: pid
    });
  });
};

// 修改显示次数
function changeShowTimes(data) {
  _getStorage(XdomainStorageKeys.SurveyShowTimes).then(function (list) {
    if (!list) {
      list = [data];
    } else {
      var item = list.find(function (x) {
        return x.id == data.id;
      });
      if (item) {
        item.showTimes = data.showTimes;
        item.originTimes = data.originTimes;
      } else {
        list.push(data);
      }
    }
    _setStorage(XdomainStorageKeys.SurveyShowTimes, list);
  });
}

// 设置显示周期
export var setShowCycle = function setShowCycle(id, triggerSetting, pid) {
  var showSetting = triggerSetting.showSetting,
    displayInterval = triggerSetting.displayInterval,
    displayIntervalUnit = triggerSetting.displayIntervalUnit,
    displayLimitPeriod = triggerSetting.displayLimitPeriod,
    displayLimitPeriodUnit = triggerSetting.displayLimitPeriodUnit,
    displayLimitTimes = triggerSetting.displayLimitTimes,
    _triggerSetting$visib = triggerSetting.visibleTiming,
    visibleTiming = _triggerSetting$visib === void 0 ? '2' : _triggerSetting$visib,
    _triggerSetting$showT = triggerSetting.showTimes,
    showTimes = _triggerSetting$showT === void 0 ? '1' : _triggerSetting$showT,
    _triggerSetting$showC = triggerSetting.showCycle,
    showCycle = _triggerSetting$showC === void 0 ? '-99' : _triggerSetting$showC;
  if (typeof showSetting === 'undefined') {
    // 老版本数据，判断 visibleTiming: 用户可见时机 "1"：一直保留，直到提交，"2"：只出现一次，即使没有任何操作，"3"：一直保留，可重复提交
    return visibleTiming == '2' && setShowOrOpen({
      id: id,
      showTimes: showTimes,
      showCycle: '-1',
      pid: pid
    });
  }
  if (showSetting === '1') {
    return;
  }
  if (showSetting === '0') {
    // 老版本数据 有展示周期，默认周期为永不
    return setShowOrOpen({
      id: id,
      showTimes: showTimes,
      showCycle: showCycle
    });
  }
  if (showSetting === '2') {
    /** 疲劳控制-未提交
     * - 问卷每2次展示最小间隔【displayInterval】【displayIntervalUnit】，在【displayLimitPeriod】【displayLimitPeriodUnit】内最多展示【displayLimitTimes】次。
     * displayInterval: 取值范围大于等于0。默认值为7
     * displayLimitPeriod: 取值范围大于等于a。快捷选项：1天、7天、30天、90天、永久时间。默认值30天
     * displayLimitTimes: 取值范围0~10。默认值为3
     * ***Unit: "天" ｜ "小时" ｜ "分钟"
     */
    _getStorage(XdomainStorageKeys.SurveyShowTimes).then(function (list) {
      // 剩余打开次数
      var remainDisplayedTimes = displayLimitTimes - 1;

      // 打开过 且 疲劳周期配置未修改时 以本地剩余打开次数判断疲劳度
      var showTimesData = list === null || list === void 0 ? void 0 : list.find(function (_ref5) {
        var localId = _ref5.id;
        return localId === id;
      });
      if (showTimesData) {
        var _showTimes = showTimesData.showTimes,
          originTimes = showTimesData.originTimes;
        if (originTimes === displayLimitTimes) {
          remainDisplayedTimes = _showTimes - 1;
        }
      }

      // 下一次显示时间
      var nextDisplayTimeOffset = 0;
      if (remainDisplayedTimes < 1) {
        // 显示次数用完时，根据 疲劳度周期控制下次打开时间
        nextDisplayTimeOffset = typeof displayLimitPeriod === 'number' ? displayLimitPeriod : Number(displayLimitPeriod) * displayLimitPeriodUnit;
        // 重制剩余打开次数
        remainDisplayedTimes = displayLimitTimes;
        if (displayLimitPeriod === 'Infinity') {
          addUnOpenSurvey(id, '-1', pid);
        } else {
          addUnOpenSurvey(id, nextDisplayTimeOffset / ONE_DAY, pid);
        }
      } else {
        nextDisplayTimeOffset = displayInterval * displayIntervalUnit;
        addUnOpenSurvey(id, nextDisplayTimeOffset / ONE_DAY, pid);
      }
      changeShowTimes({
        id: id,
        showTimes: remainDisplayedTimes,
        originTimes: displayLimitTimes,
        pid: pid
      });
    });
  }
};

// 设置提交后显示周期
export var setSubmitCycle = function setSubmitCycle(id, triggerSetting, pid) {
  var _triggerSetting$visib2 = triggerSetting.visibleTiming,
    visibleTiming = _triggerSetting$visib2 === void 0 ? '2' : _triggerSetting$visib2,
    _triggerSetting$submi = triggerSetting.submitVisibleCycle,
    submitVisibleCycle = _triggerSetting$submi === void 0 ? '-99' : _triggerSetting$submi;
  if (submitVisibleCycle == '-99') {
    // 老版本数据
    if (visibleTiming == '1' || visibleTiming == '2') {
      // 提交后不显示 // 只显示多少次
      addUnOpenSurvey(id, '-1', pid);
    }
  } else {
    // 新版本数据，有周期
    if (visibleTiming == '1' || visibleTiming == '2') {
      // 有提交展示周期
      addUnOpenSurvey(id, submitVisibleCycle, pid);
    }
  }
};

// 无痕模式和写入失败禁止打开
export var openDisabled = function openDisabled() {
  return new Promise(function (r, j) {
    try {
      // 验证localStorage是否可用
      localStorage.setItem('aes-plugin-survey-test', 'true');
      localStorage.removeItem('aes-plugin-survey-test');

      // 验证indexdb是否可用
      set('aes-plugin-survey-test', true);
      del('aes-plugin-survey-test');

      // 无痕模式
      if ('storage' in navigator && 'estimate' in navigator.storage) {
        navigator.storage.estimate().then(function (estimate) {
          if (estimate.quota < 1200000000) {
            r(true);
          }
          r(false);
        }).catch(function (_) {
          r(false);
        });
      }
      r(false);
    } catch (error) {
      r(true);
    }
  });
};
export var analysisBehaviorFrequency = function analysisBehaviorFrequency(behaviorList, pid) {
  return _getStorage(XdomainStorageKeys.SurveyBehaviorInfo).then(function (list) {
    behaviorList.forEach(function (_ref6) {
      var action = _ref6.action,
        range = _ref6.range,
        rangeDetail = _ref6.rangeDetail,
        num = _ref6.num,
        operator = _ref6.operator,
        surveyId = _ref6.surveyId;
      var item = (list || []).find(function (x) {
        return x.surveyId == surveyId;
      });
      if (!item) {
        var _list$push;
        // 缓存为空，第一次加载，直接缓存数据
        var canShow = false;
        switch (operator) {
          case '>=':
            canShow = num <= 1;
            break;
        }
        list.push((_list$push = {}, _defineProperty(_list$push, "num_".concat(action, "_").concat(range), 1), _defineProperty(_list$push, "rangeDetail", rangeDetail), _defineProperty(_list$push, "num", num), _defineProperty(_list$push, "surveyId", surveyId), _defineProperty(_list$push, "canShow", canShow), _defineProperty(_list$push, "".concat(action, "_").concat(range, "_date"), getDateFormat(Date.now())), _defineProperty(_list$push, "pid", pid), _list$push));
      } else {
        // 缓存中已存在数据
        var _canShow = false;
        if (rangeDetail == item['rangeDetail']) {
          // 是同一个指定地址
          if (action == 'timecount' || action == 'daycount' && item["".concat(action, "_").concat(range, "_date")] != getDateFormat(Date.now())) {
            // 满足全部页面或对应的指定页面是 +1
            item["num_".concat(action, "_").concat(range)] = (Number(item["num_".concat(action, "_").concat(range)]) || 0) + 1;
          }
          switch (operator) {
            case '>=':
              _canShow = num <= item["num_".concat(action, "_").concat(range)];
              break;
          }
          item["canShow"] = _canShow;
        } else {
          // 是不同一个地址 直接刷新数据
          switch (operator) {
            case '>=':
              _canShow = num <= 1;
              break;
          }
          item["num_".concat(action, "_").concat(range)] = 1;
          item["canShow"] = _canShow;
        }
        item["".concat(action, "_").concat(range, "_date")] = getDateFormat(Date.now());
      }
    });
    return list;
  }).then(function (list) {
    return _setStorage(XdomainStorageKeys.SurveyBehaviorInfo, list);
  });
};
export var getBehaviorFrequency = function getBehaviorFrequency() {
  return _getStorage(XdomainStorageKeys.SurveyBehaviorInfo).then(function (list) {
    return (list || []).filter(function (x) {
      return !x.canShow;
    });
  });
};
var getDateFormat = function getDateFormat(time) {
  var date = new Date(time);
  return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
};